import { styled } from "@mui/material";

export const KeyValueContent = styled("span")(({ theme }) => ({
  fontWeight: theme.typography.fontWeightLight,
}));
